import { C } from "./theme";
import { goalColorTokens } from "./goalColors";
import { visuallyHidden } from "./visuallyHidden";

// One short fact under a row's words: a 15px marker (a goal's colour dot, a kind's icon), then the words. `label` ("Goal",
// "Dream") is read aloud before them instead of shown, because the marker says it. Every marker is 15px wide, so the
// words of stacked lines line up; MARKED_INDENT starts an unmarked line in the same place. Task rows and Key Date cards.
export const MARKED_INDENT = 21; // the marker and the gap
export function MarkedLine({ marker, label, style, children }) {
  return (
    <span style={{ display: "flex", alignItems: "flex-start", gap: 6, marginTop: 4, fontSize: 14, lineHeight: 1.35, color: C.textMid, ...style }}>
      {marker && <span style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 15, height: 19, flexShrink: 0 }}>{marker}</span>}
      <span>{label && <span style={visuallyHidden}>{label}: </span>}{children}</span>
    </span>
  );
}

// A goal's colour dot. Its name stays in a text colour beside it, readable on both themes.
export const GoalDot = ({ goal }) => <span aria-hidden="true" style={{ width: 9, height: 9, borderRadius: "50%", background: goalColorTokens(goal.color).main }} />;
